module.exports = __webpack_public_path__ + "static/media/warehouse-alt.21dfabc2.svg";